import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { QueryClientProvider } from 'react-query'

import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import { VoidInvoiceModal } from '@views/invoices/elements/VoidInvoiceModal'

import { queryClient } from '../../config/queryClient'
import { EmberModal } from '../../contexts/emberCloseModalContext'
import { ThemeProvider } from '../../contexts/themeProvider'
import { ModalId } from '../../enums/modalId'

const MODULE_NAME = 'void-invoice-modal-module'

class VoidInvoiceModalWebComponent extends DOMModel {
  @byAttrVal invoiceId: string
  @byAttrVal organizationId: string
  @registerEvent('closeEmber') closeEmber: Function
  @registerEvent('voidInvoice') voidInvoice: Function | undefined
}

interface VoidInvoiceModalProps {
  invoiceId: string
  organizationId: string
  onCloseEmber: EmberModal
  onVoidInvoice: Function
}

function VoidInvoiceModalModule({
  invoiceId,
  organizationId,
  onCloseEmber,
  onVoidInvoice,
}: VoidInvoiceModalProps): ReactElement {
  const closeModal = useCallback(() => {
    onCloseEmber({ detail: null })
  }, [onCloseEmber])

  const voidInvoice = useCallback(() => {
    onVoidInvoice({ detail: null })
  }, [onVoidInvoice])

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ModalContextProvider>
          <CurrentUserContextProvider>
            <UserOrganizationContextProvider organizationId={organizationId}>
              <VoidInvoiceModal
                id={ModalId.VoidInvoiceModal}
                forceRender
                invoiceId={invoiceId}
                onModalClose={closeModal}
                onInvoiceVoid={voidInvoice}
              />
            </UserOrganizationContextProvider>
          </CurrentUserContextProvider>
        </ModalContextProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const VoidInvoiceModalCustomElement = createCustomElement(
  VoidInvoiceModalModule,
  VoidInvoiceModalWebComponent,
  'element',
)

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, VoidInvoiceModalCustomElement)

export default VoidInvoiceModalCustomElement
